// Shared constants used across worker and frontend

export const UNIFI_CLOUD_API_URL = 'https://api.ui.com'
export const UNIFI_DEFAULT_CLOUD_URL = 'https://unifi.ui.com'

export const DEFAULT_TENANT_COLORS = {
  accent: '#c8850a',
  primary: '#2563eb',
  sidebar: '#1c1e24',
} as const
